// import ExcelJS from 'exceljs';

// jsPDF
// import { jsPDF } from 'jspdf';
// import autoTable from 'jspdf-autotable';

// Types
import { TransportOperatorInterface } from 'store/ducks/transportOperators/types';
import { UserFirebase } from 'store/ducks/users/types';

// Helpers
import { toDataURL } from 'helpers/imageToBlob';
import { SVGToImage } from 'helpers/svgToImage';
import { maskCNPJ, maskCPF } from 'helpers/maskers';

// Contants
import IMAGES from 'constants/images';
import { formatDateAndTime } from 'helpers';
import { XlsHeaderInterface, XlsRowInterface } from '../../DialogueExport';

const getHours = () => {
  const now = new Date();
  const hours = now
    .getHours()
    .toString()
    .padStart(2, '0');
  const minutes = now
    .getMinutes()
    .toString()
    .padStart(2, '0');
  const formattedTime = `${hours}:${minutes}`;

  return `${new Date().toLocaleDateString('pt-BR')} • ${formattedTime}`;
};

const handleDownloadXls = async (
  setIsLoading: () => void,
  filters: string,
  userFirebaseData: UserFirebase,
  transportOperatorData: TransportOperatorInterface,
  xlsTitle?: string,
  xlsHeader?: XlsHeaderInterface[],
  xlsRows?: Array<XlsRowInterface[]>,
  isSpecialHeader?: boolean,
  isSpecialHeaderData?: any,
  isExtract?: boolean,
  clientData?: { name: string; document: string; period: string },
) => {
  const ExcelJS = (await import('exceljs')).default;
  const workbook = new ExcelJS.Workbook();

  const sheet = workbook.addWorksheet(xlsTitle);
  let NUMBER_OF_LINES_BEFORE_THE_BODY = isSpecialHeader ? 9 : 8;

  if (isExtract && clientData) NUMBER_OF_LINES_BEFORE_THE_BODY = 5;

  sheet.properties.defaultRowHeight = 40;
  sheet.properties.defaultColWidth = 24;
  const result = (await toDataURL(
    IMAGES.LOGOS.LOGO_ONBOARD_MOBILITY_HORIZONTAL,
  )) as { base64Url: string };

  const result2 = (await toDataURL(
    transportOperatorData?.photoUrl ||
      IMAGES.LOGOS.LOGO_ONBOARD_MOBILITY_HORIZONTAL,
  )) as { base64Url: string };

  const headerImage1 = workbook.addImage({
    base64: result.base64Url,
    extension: 'png',
  });

  const headerImage2 = workbook.addImage({
    base64: result2.base64Url,
    extension: 'png',
  });

  if (isExtract) {
    sheet.addImage(headerImage2, {
      tl: { col: 0.225, row: 0.6 },
      ext: { width: 102, height: 48 },
    });
  } else {
    sheet.addImage(headerImage1, {
      tl: { col: 0.225, row: 0.6 },
      ext: { width: 102, height: 24 },
    });
    sheet.addImage(headerImage2, {
      tl: { col: 5.225, row: 0.4 },
      ext: { width: 40, height: 40 },
    });
  }

  const ALPHABET = [
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'X',
    'W',
    'Y',
    'Z',
    'AA',
    'AB',
    'AC',
    'AD',
    'AE',
    'AF',
    'AG',
    'AH',
    'AI',
    'AJ',
  ];

  if (xlsHeader) sheet.columns = xlsHeader.map((e) => ({ ...e, header: '' }));

  if (isExtract && clientData) {
    sheet.mergeCells('C1:L1');
    sheet.mergeCells('B2:L2');
    sheet.mergeCells('C3:H3');
    sheet.mergeCells('I3:L3');
    sheet.getCell('B1').value = ` Empresa: ${transportOperatorData?.name}`;
    sheet.getCell('C1').value = ` ${xlsTitle}`;
    sheet.getCell('A2').value = ` Cliente:`;
    sheet.getCell('B2').value = ` ${clientData.name}`;
    sheet.getCell('A3').value = ` CPF:`;
    sheet.getCell('B3').value = `${
      clientData.document ? maskCPF(clientData.document) : ''
    }`;
    sheet.getCell('C3').value = ` De: ${clientData.period}`;
    sheet.getCell('I3').value = ` Data Hora Emissao: ${formatDateAndTime(
      new Date(),
    )}`;

    sheet.getCell('B1').alignment = {
      vertical: 'middle',
    };
    sheet.getCell('C1').alignment = {
      horizontal: 'center',
      vertical: 'middle',
    };
    sheet.getCell('C1').font = {
      name: 'Roboto',
      family: 4,
      size: 28,
      bold: true,
      color: { argb: '14171A' },
    };

    Array.from(Array(3).keys()).forEach((i) => {
      if (i > 0) {
        sheet.getRow(i + 1).height = 26;
        sheet.getRow(i + 1).eachCell(
          (cell) =>
            (cell.alignment = {
              vertical: 'middle',
            }),
        );
      }

      sheet.getRow(i + 1).eachCell(
        (cell) =>
          (cell.border = {
            left: { style: 'thin', color: { argb: '000' } },
            right: { style: 'thin', color: { argb: '000' } },
            bottom: {
              style: 'thin',
              color: { argb: '000' },
            },
          }),
      );
      sheet.getRow(1).height = 52;
    });
  } else {
    sheet.addRow([]);
    sheet.addRow([]);
    sheet.addRow([]);
    sheet.addRow([]);
    sheet.mergeCells('A1:E1');
    sheet.mergeCells('F1:K1');
    sheet.getCell('A2').value = ` ${xlsTitle}`;
    sheet.getCell('F2').value = ' Operadora de Transporte';
    sheet.getCell('A3').value = `   ID: ${
      userFirebaseData?.uid ? userFirebaseData?.uid?.slice(0, 15) : '--'
    }`;
    sheet.getCell('F3').value = `   Nome: ${transportOperatorData?.name}`;
    sheet.getCell('A4').value = `   ${getHours()}`;
    sheet.getCell('F4').value = `   CNPJ: ${
      transportOperatorData?.cnpj ? maskCNPJ(transportOperatorData?.cnpj) : '--'
    }`;
    Array.from(Array(3).keys()).forEach((i) => {
      if (i + 1 !== 2) {
        sheet.getRow(i + 1).font = {
          size: 12,
        };
      }
    });

    Array.from(Array(3).keys()).forEach((i) => {
      sheet.getRow(i + 2).height = 26;
      sheet.mergeCells(`A${i + 2}}:E${i + 2}}`);
      sheet.mergeCells(`F${i + 2}}:K${i + 2}}`);
      sheet.getCell(`A${i + 2}}`).alignment = {
        vertical: 'middle',
        horizontal: 'justify',
      };
      sheet.getCell(`F${i + 2}}`).alignment = {
        vertical: 'middle',
        horizontal: 'justify',
      };
      sheet.getRow(i + 2).font = {
        name: 'Roboto',
        family: 4,
        color: { argb: '14171A' },
      };
    });

    sheet.getRow(2).font = {
      name: 'Roboto',
      family: 4,
      size: 14,
      color: { argb: '14171A' },
    };
    sheet.mergeCells('A5:L5');
    sheet.getCell('A5').value = `   ${filters.replace(',', ' // ')}`;
    sheet.getCell(`A5`).alignment = {
      vertical: 'middle',
      horizontal: 'justify',
    };
    sheet.getRow(5).eachCell(
      (cell) =>
        (cell.border = {
          top: { style: 'thick', color: { argb: 'E1E8ED' } },
          bottom: {
            style: 'thick',
            color: { argb: 'E1E8ED' },
          },
        }),
    );
    sheet.getRow(5);
    sheet.addRow([]);
    sheet.getRow(6).height = 20;
  }

  if (isSpecialHeader) {
    if (xlsHeader) {
      sheet.columns = xlsHeader.map((e) => ({ ...e, header: '' }));
      const auxHeaderRow: { [key: string]: string } = {};

      xlsHeader.forEach((e) => (auxHeaderRow[e.key] = ''));
      sheet.addRow(auxHeaderRow);
      sheet.getRow(7).height = 40;

      sheet.getRow(7).eachCell(
        (cell) =>
          (cell.fill = {
            bgColor: { argb: '000000' },
            type: 'pattern',
            pattern: 'solid',
          }),
      );

      sheet.getRow(7).font = {
        name: 'Roboto',
        family: 4,
        size: 12,
        color: { argb: 'FFFFFF' },
      };

      sheet.getRow(7).border = {
        bottom: {
          style: 'thin',
          color: { argb: 'FFFFFF' },
        },
      };

      const result2 = (await toDataURL(
        'https://i.imgur.com/Jiy4fo6.png' ||
          IMAGES.ICONS.PASSENGERS_BY_TERMINAL,
      )) as { base64Url: string };

      const headerImage2 = workbook.addImage({
        base64: result2.base64Url,
        extension: 'png',
      });

      sheet.addImage(headerImage2, {
        tl: { col: 0.225, row: 6.1 },
        ext: { width: 40, height: 40 },
      });

      sheet.getRow(7).getCell(1).value = isSpecialHeaderData?.terminal
        ? isSpecialHeaderData?.terminal
        : '';
      sheet.getRow(7).getCell(3).font = {
        name: 'Roboto',
        family: 4,
        size: 13,
        color: { argb: 'FFFFFF' },
      };
      sheet.getRow(7).getCell(1).border = {
        right: {
          style: 'thin',
          color: { argb: 'FFFFFF' },
        },
      };

      sheet.mergeCells('A7:B7');

      sheet.getRow(7).getCell(3).value = isSpecialHeaderData?.isFinancial
        ? 'Fluxo Financeiro'
        : 'Fluxo Transportado';
      sheet.getRow(7).getCell(3).font = {
        name: 'Roboto',
        family: 4,
        size: 18,
        color: { argb: 'FFFFFF' },
      };

      sheet.mergeCells('C7:D7');

      sheet.getRow(7).getCell(isSpecialHeaderData?.columns - 1).value =
        'PoweredBy: ';

      const result3 = (await toDataURL(
        'https://i.imgur.com/HaOXSW7.png' ||
          IMAGES.LOGOS.LOGO_ONBOARD_MOBILITY_SMALL_WHITE,
      )) as { base64Url: string };

      const headerImage3 = workbook.addImage({
        base64: result3.base64Url,
        extension: 'png',
      });

      sheet.addImage(headerImage3, {
        tl: { col: isSpecialHeaderData?.columns - 1, row: 6.55 },
        ext: { height: 12, width: 75 },
      });

      // sheet.mergeCells('F7:H7');

      sheet.columns = xlsHeader.map((e) => ({ ...e, header: '' }));
      const auxHeaderRowSecond: { [key: string]: string } = {};

      xlsHeader.forEach((e) => (auxHeaderRowSecond[e.key] = ''));
      sheet.addRow(auxHeaderRowSecond);
      sheet.getRow(8).eachCell(
        (cell) =>
          (cell.fill = {
            bgColor: { argb: '000000' },
            type: 'pattern',
            pattern: 'solid',
          }),
      );

      sheet.getRow(8).font = {
        name: 'Roboto',
        family: 4,
        size: 16,
        color: { argb: 'FFFFFF' },
      };

      sheet.getRow(8).border = {
        bottom: {
          style: 'thin',
          color: { argb: 'FFFFFF' },
        },
      };

      sheet.getRow(8).getCell(2).border = {
        right: {
          style: 'thin',
          color: { argb: 'FFFFFF' },
        },
        bottom: {
          style: 'thin',
          color: { argb: 'FFFFFF' },
        },
      };

      sheet.columns = xlsHeader.map((e) => ({ ...e, header: '' }));
      const auxHeaderRowHeader: { [key: string]: string } = {};

      xlsHeader.forEach((e) => (auxHeaderRowHeader[e.key] = e.header));
      sheet.addRow(auxHeaderRowHeader);
      sheet.getRow(9).eachCell(
        (cell) =>
          (cell.fill = {
            bgColor: { argb: '000000' },
            type: 'pattern',
            pattern: 'solid',
          }),
      );

      sheet.getRow(9).font = {
        name: 'Roboto',
        family: 4,
        size: 16,
        color: { argb: 'FFFFFF' },
      };
    }
  } else if (xlsHeader) {
    const auxHeaderRow: { [key: string]: string } = {};
    xlsHeader.forEach((e) => (auxHeaderRow[e.key] = e.header));
    sheet.addRow(auxHeaderRow);
  }

  if (xlsRows) {
    const promise = Promise.all(
      xlsRows.map(async (data, index) => {
        const row = index + NUMBER_OF_LINES_BEFORE_THE_BODY - 1;
        const auxRow: { [key: string]: string } = {};

        data.forEach((obj) => {
          if (obj.image) {
            auxRow[obj.key] = '';
          } else {
            auxRow[obj.key] = obj.value;
          }
        });

        sheet.addRow(auxRow);

        let col = 0;
        for await (const obj of data) {
          if (obj.image && obj.image.path) {
            const auxStringArr = obj.image.path.split('.');
            const isSvg = auxStringArr[auxStringArr.length - 1] === 'svg';

            if (isSvg) {
              const svgInLine = await fetch(obj.image.path)
                .then((response) => response.text())
                .then((text) => text)
                .catch((err) => {
                  console.error({ err });
                });

              const base64 = await SVGToImage({
                svg: svgInLine || '',
                mimetype: 'image/png',
                width: obj.image.width,
                height: obj.image.height,
                quality: 1,
                outputFormat: 'base64',
              })
                .then((outputData) => outputData)
                .catch((err) => {
                  console.error({ err });
                });
              const extName = 'png';

              if (base64) {
                const imageId = workbook.addImage({
                  base64: base64 as string,
                  extension: extName,
                });

                sheet.addImage(imageId, {
                  tl: { col: col + 0.9, row: row + 0.8 },
                  ext: { width: obj.image.width, height: obj.image.height },
                });
              }
            } else {
              const auxStringArr = obj.image.path.split('.');
              const isPng = auxStringArr[auxStringArr.length - 1] === 'png';
              const extensionName = isPng ? 'png' : 'jpeg';

              const result = (await toDataURL(obj.image.path)) as {
                base64Url: string;
              };

              const imageId = workbook.addImage({
                base64: result.base64Url,
                extension: extensionName,
              });
              sheet.addImage(imageId, {
                tl: { col: col + 0.9, row: row + 0.8 },
                ext: { width: obj.image.width, height: obj.image.height },
              });
            }
          }

          col += 1;
        }
      }),
    ).catch((error) => console.log({ error }));

    promise.then(() => {
      if (isExtract && clientData) {
        sheet.getRow(4).fill = {
          fgColor: { argb: '14171A' },
          type: 'pattern',
          pattern: 'solid',
        };
        sheet.getRow(4).font = {
          name: 'Roboto',
          family: 4,
          size: 14,
          color: { argb: 'FFFFFF' },
        };
        sheet.getRow(4).height = 30;
      } else {
        sheet.getRow(7).fill = {
          fgColor: { argb: '14171A' },
          type: 'pattern',
          pattern: 'solid',
        };

        sheet.getRow(7).font = {
          name: 'Roboto',
          family: 4,
          size: 14,
          color: { argb: 'FFFFFF' },
        };
        sheet.getRow(7).height = 30;
      }

      xlsRows.map(async (data, row) => {
        sheet.getRow(row + NUMBER_OF_LINES_BEFORE_THE_BODY).height = 26;
        if (row % 2 !== 0) {
          sheet.getRow(row + NUMBER_OF_LINES_BEFORE_THE_BODY).eachCell(
            (cell) =>
              (cell.fill = {
                bgColor: { argb: isSpecialHeader ? 'FFFFFF' : 'F5F8FA' },
                type: 'pattern',
                pattern: 'none',
              }),
          );
        }
      });

      // if metrics ou Shipments add gray border
      xlsRows.map(async (data, row) => {
        if (
          data?.[0]?.value === 'Métricas' ||
          data?.[0]?.value === 'Embarques'
        ) {
          sheet.getRow(row + NUMBER_OF_LINES_BEFORE_THE_BODY).eachCell(
            (cell) =>
              (cell.border = {
                top: { style: 'thick', color: { argb: 'E1E8ED' } },
                bottom: {
                  style: 'thick',
                  color: { argb: 'E1E8ED' },
                },
              }),
          );
        }
      });

      workbook.xlsx
        .writeBuffer()
        .then((data: any) => {
          const blob = new Blob([data], {
            type:
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          });
          const url = window.URL.createObjectURL(blob);
          const anchor = document.createElement('a');
          anchor.href = url;
          anchor.download = `${xlsTitle}.xlsx`;
          anchor.click();
          window.URL.revokeObjectURL(url);
        })
        .then(() => setIsLoading())
        .catch((error) => console.log({ error }));
    });

    xlsRows.map(async (data, row) => {
      data.forEach((_, col) => {
        if (row === 0) {
          if (isExtract && clientData) {
            sheet.getCell(`${ALPHABET[col]}4`).alignment = {
              vertical: 'middle',
              horizontal: 'center',
            };
          } else {
            sheet.getCell(`${ALPHABET[col]}7`).alignment = {
              vertical: 'middle',
              horizontal: 'center',
            };
          }
        }

        sheet.getCell(
          `${ALPHABET[col]}${row + NUMBER_OF_LINES_BEFORE_THE_BODY}`,
        ).alignment = {
          vertical: 'middle',
          horizontal: 'center',
        };
      });
    });
  }
};

export class WebWorker {
  constructor(worker: any) {
    let code = String(worker);
    code = code.substring(code.indexOf('{') + 1, code.lastIndexOf('}'));

    const blob = new Blob([code], { type: 'application/javascript' });
    return new Worker(URL.createObjectURL(blob));
  }
}

export async function MyWorkerWithParam(
  columnsPerPage: number,
  simplePdfData: any,
  setIshandering: (param: boolean) => void,
  transportOperatorPhotoUrl: string | undefined | null,
  userFirebaseUid: string,
  transportOperatorName: string,
  transportOperatorCnpj: string,
  pdfName: string,
  headerFontSize?: number,
  bodyFontSize?: number,
  isExtract?: boolean,
  userId?: string,
  totalRow?: boolean,
  isLandscape?: boolean,
) {
  const getHours = () => {
    const now = new Date();
    const hours = now
      .getHours()
      .toString()
      .padStart(2, '0');
    const minutes = now
      .getMinutes()
      .toString()
      .padStart(2, '0');
    const formattedTime = `${hours}:${minutes}`;

    return `${new Date().toLocaleDateString('pt-BR')} • ${formattedTime}`;
  };
  const hour = getHours();

  const { default: jsPDF } = await import('jspdf');

  const autoTable = (await import('jspdf-autotable')).default;

  const totalColumns = simplePdfData?.headers?.length || 0;

  // Determinar tamanho da página baseado no número de colunas quando em modo paisagem
  let pageFormat: any = 'a4';
  if (isLandscape && totalColumns > 20) {
    if (totalColumns <= 30) {
      pageFormat = 'a3'; // A3: 1191 x 842 pt (landscape)
    } else if (totalColumns <= 45) {
      pageFormat = 'a2'; // A2: 1684 x 1191 pt (landscape)
    } else {
      // Página customizada para muitas colunas (aproximadamente 50-60pt por coluna)
      const customWidth = Math.max(1684, totalColumns * 55);
      pageFormat = [customWidth, 1191]; // Largura customizada x altura A2
    }
  }

  const doc = new jsPDF(isLandscape ? 'l' : 'p', 'pt', pageFormat) as any;

  // Se modo paisagem está ativo, não quebrar a tabela
  const totalPages = isLandscape ? 1 : Math.ceil(totalColumns / columnsPerPage);

  const el = `
  <html>
  <body><div style="width:100%;display:flex">
  <div style="width:55%"><div style="padding-top:16px; padding-left:4px"><img style="max-width:102px;max-height:24px;object-fit:contain" src="${
    IMAGES.LOGOS.LOGO_ONBOARD_MOBILITY_BLACK
  }"/> ${
    isExtract
      ? `</div><p style=" font-size: 16px;font-weight:600">${simplePdfData?.userName}</p>
  <p  style="text-align: left; font-size: 10px"> ID:
  ${userId}</p>
  </div>`
      : `</div><p style=" font-size: 16px;font-weight:600">${simplePdfData?.subtitle}</p>
  <p  style="text-align: left; font-size: 10px"> ID:
  ${userFirebaseUid}</p>
  </div>`
  }

  <div style="width:45%;display:flex;justify-content:space-between">
  <div  style="width:20%"><div style="padding-top:16px">
  <img style="max-width:102px;max-height:24px;object-fit:contain" src="${transportOperatorPhotoUrl ||
    IMAGES.LOGOS.LOGO_ONBOARD_MOBILITY_BLACK}"/> </div>
  </div>
  <div  style="width:80%">
${
  isExtract
    ? ''
    : `<p style=" font-size: 12px;  text-align: left">Operadora de Transporte</p>
<p style=" font-size: 12px;  text-align: left">
<span style=" font-size: 12px;  text-align: left">
Nome:
</span>
<span style=" font-size: 12px;  text-align: left">
</span>`
}
      <span style=" font-size: 12px;font-weight:normal">
      ${transportOperatorName}
      </span>
      </p>
      <p style=" font-size: 12px;  text-align: left">
      <span style=" font-size: 12px;  text-align: left">
      CNPJ:
      </span>
      <span style=" font-size: 12px;  text-align: left">
      </span>
      <span style=" font-size: 12px;font-weight:normal">
      ${transportOperatorCnpj}
      </span>
      </p>
      <p  style="text-align: left; font-size: 10px">${hour}</p>
      </div>
      </div>
      </div>

      <div style="width:100%;border-top:1px solid #E1E8ED; border-bottom:1px solid #E1E8ED; margin-top:4px; margin-bottom: 16px; padding-top:8px; padding-bottom:8px">

      <div style="width:100%;display:flex; padding-top:8px; padding-bottom:8px">
      ${simplePdfData?.filters.replace(',', ' // ')}
      </div>
         <div style="width:100%;display:flex;gap:16px;margin-bottom:8px;padding-left:4px;flex-wrap:wrap">
      ${(simplePdfData?.details || [])
        .map(
          (d: any) =>
            `<div style="min-width:80px;font-size: 10px;display:flex;flex-direction:column"><span style="font-size:10px;font-weight:600;color:#14171A">${d.title}</span><span style="font-size:10px;color:#14171A">${d.value}</span></div>`,
        )
        .join('')}
      </div>
      </div>

      </html>
  </body>`;

  await doc.html(el, {
    windowWidth: 566,
    width: 566,
    margin: 12,
    x: 0,
    y: 0,
  });

  for (let pageIndex = 1; pageIndex <= totalPages; pageIndex++) {
    // Generate Header
    // Se modo paisagem, pegar TODAS as colunas, senão fazer paginação
    const auxHeader = isLandscape
      ? simplePdfData?.headers
      : simplePdfData?.headers?.slice(
          (pageIndex - 1) * columnsPerPage,
          pageIndex * columnsPerPage,
        );

    const head = auxHeader.map((header: any) => header);

    // Generate Body
    // Se modo paisagem, pegar TODAS as células de cada linha
    const body = isLandscape
      ? simplePdfData?.rows
      : simplePdfData?.rows?.map((row: any, rowIndex: any) =>
          row
            ?.slice(
              (pageIndex - 1) * columnsPerPage,
              pageIndex * columnsPerPage,
            )
            ?.map(
              (cell: any, cellIndex: any) =>
                simplePdfData.rows?.[rowIndex]?.[
                  cellIndex + (pageIndex - 1) * columnsPerPage
                ],
            ),
        );

    autoTable(doc, {
      startY: pageIndex === 1 ? 240 : undefined,
      head: [head],
      body,
      headStyles: {
        fillColor: '#000',
        fontSize: headerFontSize || 7,
      },
      bodyStyles: {
        fontSize: bodyFontSize || 7,
        cellPadding: 4,
      },
      didParseCell(data) {
        if (totalRow) {
          const rows = data.table.body;
          if (data.row.index === rows.length - 1) {
            data.cell.styles.fontStyle = 'bold';
            data.cell.styles.lineColor = '#000';
            data.cell.styles.lineWidth = {
              top: 1,
              bottom: 1,
            };
          }
        }
      },

      margin: { top: 16, bottom: 8, left: 4, right: 4 },
      styles: {
        minCellHeight: totalColumns > 30 ? 8 : 10,
        halign: 'left',
        valign: 'middle',
        overflow: 'linebreak',
        cellWidth: isLandscape ? 'auto' : undefined,
      },
      tableWidth: isLandscape ? 'auto' : undefined,
    });
    if (pageIndex === totalPages) {
      setIshandering(false);
      doc.save(`${pdfName}.pdf`);
      postMessage({ result: true });
    }
  }
  if (simplePdfData?.rows.length === 0) {
    setIshandering(false);
  }
}

export { handleDownloadXls };
